import Image from '@repo/ui/src/components/Image/New';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { HorizontalAlignmentEnum } from '@repo/ui/src/enums/shared-enums';
import { classNames } from '@repo/ui/src/utils/classNames';
import { LinkProps, ImageProps } from '@repo/ui/src/types';
import { navigationClicked } from '@repo/ui/src/services/analytics';

export interface NavigationPromoProps {
  links: Array<LinkProps>;
  title: string;
  image?: ImageProps;
  align?: 'left' | 'center' | 'right';
  primaryHeader?: string;
  secondaryHeader?: string;
}

const fullHorizontalAlignmentClasses = {
  [HorizontalAlignmentEnum.Left]: 'tw-items-left',
  [HorizontalAlignmentEnum.Center]: 'tw-items-center tw-text-center',
  [HorizontalAlignmentEnum.Right]: 'tw-items-end tw-text-right',
};

const NavigationPromo = ({
  title,
  links,
  image,
  align = 'center',
  primaryHeader,
  secondaryHeader,
}: NavigationPromoProps) => {
  return (
    <div
      className="tw-relative tw-w-full tw-h-fit tw-min-h-[118px] tw-rounded"
      role="complementary"
      aria-labelledby="nav-promo-title"
    >
      {image?.image?.url && (
        <div className="tw-absolute tw-inset-0">
          <Image
            src={image.image.url}
            alt="Promo background"
            fill
            className="tw-object-cover tw-rounded"
          />
        </div>
      )}
      <div
        className={classNames(
          'tw-relative tw-flex tw-w-full tw-h-full tw-py-7 tw-px-10 tw-flex-col tw-gap-3 tw-z-10',
          align && fullHorizontalAlignmentClasses[align],
        )}
      >
        <h5 className="tra-text-web-heading-5" id="nav-promo-title">
          {title}
        </h5>
        <div className={classNames('tw-flex tw-flex-row tw-gap-4')}>
          {links?.map((link, i) => (
            <Anchor
              {...link}
              className="tra-text-web-body-m-link"
              key={i}
              onClick={() =>
                navigationClicked({
                  nav_type: 'Top Navigation',
                  clicked_text: link.displayName ?? '',
                  primary_header: primaryHeader ?? '',
                  secondary_header: secondaryHeader ?? '',
                  tertiary_header: `${title ? title + ' ' : ''}${link.displayName}`,
                })
              }
            />
          ))}
        </div>
      </div>
      <div className="tw-absolute tw-inset-0 tw-bg-[rgba(0,0,0,0.4)] tw-rounded" />
    </div>
  );
};

export default NavigationPromo;
